module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link-btn",
    class: {
      online: _vm.streamStatus === 'ONLINE', offline: _vm.streamStatus !== 'ONLINE'
    },
    attrs: {
      "href": 'https://www.twitch.tv/' + _vm.channelName,
      "aria-label": 'external link: stream is currently ' + _vm.streamStatus,
      "title": 'Twitch.tv/' + _vm.channelName
    }
  }, [_vm._v(_vm._s(_vm.streamStatus))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8321cbde","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/StreamStatus.vue
// module id = 1049
// module chunks = 2 3